define('fukit/model/find.first.query.model',['require','exports','module','underscore','backbone','./base.model','../collection/base.collection','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _              = require('underscore'),
      Backbone       = require('backbone'),
      BaseModel      = require('./base.model'),
      BaseCollection = require('../collection/base.collection'),
      Promise        = require('bluebird');

  var FindFirstQueryModel = Backbone.Model.extend({
    // should the model be cleared when the query collection
    // returns empty
    clearOnEmpty: true,
    // should the model be cleared when the query collection
    // throws an error
    clearOnError: false,
    // should the model use the query collection for just the first fetch
    // or for every fetch
    queryFirstFetchOnly: true,
    // use the given attributes as filters to fetch by
    filterUsingAttributes: [],
  });

  FindFirstQueryModel.extend = function(protoMethods, staticMethods) {
    protoMethods = _.extend(
      {
        clearOnEmpty: true,
        clearOnError: false,
        queryFirstFetchOnly: true,
      },
      protoMethods
    );

    //prettier-ignore
    var collectionClass = protoMethods.collection || Backbone.Collection,
        modelClass      = protoMethods.model || collectionClass.prototype.model || Backbone.Model,
        fetch           = modelClass.prototype.fetch;

    return modelClass.extend({
      initialize: function() {
        modelClass.prototype.initialize.apply(this, arguments);
        this.collection = new collectionClass();

        if (this.collection instanceof BaseCollection) {
          // copy the SPF properties over for
          // easy access
          this.sort = this.collection.sort;
          this.paginate = this.collection.paginate;
          this.filters = this.collection.filters;
          _.each(
            _.result(protoMethods, 'filterUsingAttributes'),
            function(attr) {
              var filterModel = this.collection.filters.add({ field: attr });
              filterModel.set('value', this.get(attr));
              this.on(
                'change:' + attr,
                function() {
                  filterModel.set('value', this.get(attr));
                },
                this
              );
            },
            this
          );
        }
      },
      fetch: function(options) {
        options || (options = {});
        //prettier-ignore
        var model      = this,
            collection = this.collection,
            xhr        = collection.fetch(),
            thenable   = xhr;

        if (xhr.promise) {
          thenable = _.result(xhr, 'promise');
        }

        Promise.resolve(thenable)
          .tap(function(response) {
            if (collection.length > 0) {
              model.set(collection.first().attributes, options);
            } else if (_.result(protoMethods, 'clearOnEmpty')) {
              model.clear(options);
            }
            if (_.result(protoMethods, 'queryFirstFetchOnly')) {
              // restore fetch method back to original
              model.fetch = fetch;
            }
            model.trigger('sync', model, response, options);
          })
          .catch(function(e) {
            if (_.result(protoMethods, 'clearOnError')) {
              model.clear(options);
            }
            model.trigger('error', model, e, options);
            throw e;
          });

        return xhr;
      },
    });
  };

  module.exports = FindFirstQueryModel;
});

